import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function CorbettLuxurycottages() {
    const heading = "Luxury Cottages";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Corbett Room</span> {heading}
                    </>
                ),
        breadcrumb: [
        {
            slug: "/resort-de-coracao-corbett/room-listing",
            name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
        },
        {
            slug: "",
            name: "Luxury Cottages",
        },
        ]
    }

    const roomBanner = {
        image: "/image/corbett-luxury-cottages-room-detail.webp",
    };

    const roomQuote = {
        content: "We know a trip to the forest isn’t complete without your four-legged companions. Our Luxury Cottages are pet-friendly, offering plenty of room for both you and your pets to relax. With easy access to the gardens and a layout that feels open and airy, it’s the best spot for families who don't want to leave anyone behind.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "41",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/corbett-luxury-cotage-room-gallery-1.webp"},
        { image: "/image/corbett-luxury-cotage-room-gallery-2.webp"},
        { image: "/image/corbett-luxury-cotage-room-gallery-3.webp"},
        { image: "/image/corbett-luxury-cotage-room-gallery-4.webp"},
        { image: "/image/corbett-luxury-cotage-room-gallery-5.webp"},
    ];

    const roomEquipment = {
        description: "Relax in a well-appointed room where modern comforts and thoughtful details create a warm and inviting stay.",
        equipment: [
        [
            "Pet-friendly space and easy outdoor access",
            "Tea and Coffee brewing station",
            "42-inch LED TV with DTH connections",
            "Personal In-Room Safe for electronics",
        ],
        [
            "Mini-Refrigerator for personal use",
            "Writing Desk with accessible outlets",
            "Pocketed Spring Mattress for a restful night",
            "High-speed Wi-Fi access throughout",
        ],
        [
            "Hydropneumatic pressure shower",
            "Soft 100% Cotton Duvets and Linens",
            "Hair Dryer and Makeup Mirror",
            "24-Hour Room Service for all-day dining",
        ]
    ]
    };

    const roomBook = {
        location: "Corbett",
        title: "Luxury Cottages",
        desc: "Enjoy a relaxed forest getaway in the Luxury Cottages at De Coracao, designed with families and pet owners in mind. With spacious interiors, garden access, comfortable amenities, and a welcoming atmosphere, they offer an easy, memorable stay surrounded by nature.",
        details: [
            "1 King Size Bed + 1 Extra Mattress Allowed",
            "Up to 3 Guests",
            "41 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Club Cottages',
                bg: '/image/corbett-other-room-1.webp',
                slug: '/resort-de-coracao-corbett/club-cottages',
                details: [
                "1 King Size Bed + 1 Extra Mattress Allowed",
                "Up to 4 Guests",
                "42 sq.mt",
                ],
            },
            
            {
                title: 'Premium Cottages',
                bg: '/image/corbett-other-room-2.webp',
                slug: '/resort-de-coracao-corbett/premium-cottages',
                details: [
               "1 King Size Bed + 1 Extra Mattress Allowed",
                "Up to 3 Guests",
                "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Room',
                bg: '/image/corbett-other-room-4.webp',
                slug: '/resort-de-coracao-corbett/luxury-room',
                details: [
                 "1 King Size Bed + 1 Extra Mattress Allowed",
                "Up to 3 Guests",
                "37 sq.mt",
                ],
            },

            {
                title: 'Family Cottages',
                bg: '/image/corbett-other-room-5.webp',
                slug: '/resort-de-coracao-corbett/family-cottages',
                details: [
                "2 King Size Beds + 1 Extra Mattress Allowed",
                "Up to 6 Guests",
                "67 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-corbett/room-listing"}
    }

  return (
    <>  
        <Subheader subheadData={subheadData} />
        <RoomBanner roomBanner={roomBanner}/>
        <RoomQuote roomQuote={roomQuote}/>
        <RoomCount roomCount={roomCount}/>
        <RoomGallery roomGallery={roomGallery}/>
        <RoomEquipment roomEquipment={roomEquipment}/>
        <RoomBook roomBook={roomBook}/>
        <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
    </>
  )
}
